import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700" }
const _hoisted_3 = { class: "px-6 py-4" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "flex items-center space-x-4" }
const _hoisted_6 = { class: "flex items-center space-x-2" }
const _hoisted_7 = { class: "text-2xl font-bold text-gray-900 dark:text-white" }
const _hoisted_8 = { class: "p-6" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-center py-24"
}
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-24"
}
const _hoisted_11 = { class: "text-xl text-gray-600 dark:text-gray-400" }
const _hoisted_12 = {
  key: 2,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-6"
}
const _hoisted_13 = { class: "bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700" }
const _hoisted_14 = { class: "p-6" }
const _hoisted_15 = { class: "space-y-4" }
const _hoisted_16 = { class: "flex justify-between items-start" }
const _hoisted_17 = { class: "text-sm font-mono text-gray-900 dark:text-white text-right" }
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_22 = { class: "flex justify-between items-center" }
const _hoisted_23 = { class: "flex justify-between" }
const _hoisted_24 = { class: "text-sm font-semibold text-blue-600 dark:text-blue-400" }
const _hoisted_25 = { class: "bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700" }
const _hoisted_26 = { class: "p-6" }
const _hoisted_27 = { class: "space-y-4" }
const _hoisted_28 = { class: "flex justify-between items-start" }
const _hoisted_29 = { class: "text-sm font-medium text-gray-900 dark:text-white text-right" }
const _hoisted_30 = { class: "flex justify-between" }
const _hoisted_31 = { class: "text-sm font-semibold text-blue-600 dark:text-blue-400" }
const _hoisted_32 = { class: "flex justify-between" }
const _hoisted_33 = { class: "text-sm font-mono text-gray-900 dark:text-white" }
const _hoisted_34 = { class: "flex justify-between items-center" }
const _hoisted_35 = { class: "flex items-center space-x-2" }
const _hoisted_36 = { class: "w-8 h-8 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full flex items-center justify-center" }
const _hoisted_37 = { class: "text-xs font-bold text-white" }
const _hoisted_38 = { class: "text-sm text-gray-900 dark:text-white" }
const _hoisted_39 = { class: "bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 lg:col-span-2" }
const _hoisted_40 = { class: "p-6" }
const _hoisted_41 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_42 = { class: "flex justify-between items-center mb-2" }
const _hoisted_43 = { class: "text-sm font-medium text-gray-900 dark:text-white font-mono bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-md" }
const _hoisted_44 = { class: "flex flex-col" }
const _hoisted_45 = { class: "flex justify-between items-center mb-2" }
const _hoisted_46 = { class: "text-xs font-mono text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-900 px-4 py-3 rounded-lg break-all border border-gray-200 dark:border-gray-700" }
const _hoisted_47 = {
  key: 0,
  class: "bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 lg:col-span-2"
}
const _hoisted_48 = { class: "p-6" }
const _hoisted_49 = { class: "flex items-center justify-between mb-4" }
const _hoisted_50 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center" }
const _hoisted_51 = { class: "flex items-center space-x-3" }
const _hoisted_52 = { class: "overflow-x-auto" }
const _hoisted_53 = { class: "w-full" }
const _hoisted_54 = { class: "divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_55 = { class: "px-4 py-3" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "px-4 py-3" }
const _hoisted_58 = {
  key: 0,
  class: "inline-flex items-center px-2.5 py-1 rounded-md text-xs font-mono bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 font-semibold"
}
const _hoisted_59 = {
  key: 1,
  class: "text-sm text-gray-400 dark:text-gray-500"
}
const _hoisted_60 = { class: "px-4 py-3" }
const _hoisted_61 = { class: "flex items-center space-x-2" }
const _hoisted_62 = { class: "flex flex-wrap gap-1.5" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 0,
  class: "flex flex-wrap gap-1.5 mt-2"
}
const _hoisted_65 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_66 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_67 = { class: "flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_68 = { class: "flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_69 = { class: "px-6 py-4 max-h-[70vh] overflow-y-auto" }
const _hoisted_70 = { class: "font-mono text-sm text-gray-800 dark:text-gray-200 bg-gray-50 dark:bg-gray-900 p-6 rounded-lg border border-gray-200 dark:border-gray-700" }
const _hoisted_71 = { class: "whitespace-pre overflow-x-auto pl-4" }
const _hoisted_72 = { class: "flex items-center justify-end px-6 py-4 border-t border-gray-200 dark:border-gray-700 space-x-3" }
const _hoisted_73 = { class: "flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_74 = { class: "flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_75 = { class: "px-6 py-4" }
const _hoisted_76 = { class: "flex items-center justify-between px-6 py-4 border-t border-gray-200 dark:border-gray-700" }

import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { workloadService } from '../../services/workload'
import type { WorkloadDetail } from '../../types/workload'
import { logger } from '../../utils/logger'
import * as d3 from 'd3'

interface DepTreeNode {
  name: string
  children: DepTreeNode[]
}

// Format dependency tree for display

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const workloadDetail = ref<WorkloadDetail | null>(null)
const loading = ref(false)
const error = ref<string | null>(null)
const copied = ref(false)
const packageSearchQuery = ref('')
const expandedPackages = ref<Set<string>>(new Set())
const showDepTreeModal = ref(false)
const showD3Modal = ref(false)
const d3Container = ref<HTMLElement | null>(null)

// Get route params
const workloadName = computed(() => route.params.workload as string)
const gitRepo = computed(() => route.params.gitRepo as string)
const environment = computed(() => route.params.environment as string)

// Filtered packages based on search query
const filteredPackages = computed(() => {
  if (!workloadDetail.value?.packages) return {}

  const query = packageSearchQuery.value.toLowerCase().trim()
  if (!query) return workloadDetail.value.packages

  const filtered: Record<string, string[]> = {}
  Object.entries(workloadDetail.value.packages).forEach(([packageName, versions]) => {
    if (packageName.toLowerCase().includes(query)) {
      filtered[packageName] = versions
    }
  })
  return filtered
})

// Interface for dependency tree node
const formattedDepTree = computed(() => {
  if (!workloadDetail.value?.depTree) return ''

  try {
    const tree: DepTreeNode[] = JSON.parse(workloadDetail.value.depTree)
    return formatTreeNodes(tree, '', true)
  } catch (err) {
    logger.error('Failed to parse dependency tree:', err)
    return 'Error parsing dependency tree'
  }
})

// Recursive function to format tree nodes (yarn list style)
const formatTreeNodes = (nodes: DepTreeNode[], prefix: string, isRoot: boolean): string => {
  let result = ''
  nodes.forEach((node, index) => {
    const isLast = index === nodes.length - 1
    
    if (isRoot) {
      // Root level items
      result += `├─ ${node.name}\n`
      if (node.children && node.children.length > 0) {
        result += formatTreeNodes(node.children, '│  ', false)
      }
    } else {
      // Nested items
      const connector = isLast ? '└─ ' : '├─ '
      const childPrefix = isLast ? '   ' : '│  '
      
      result += `${prefix}${connector}${node.name}\n`
      
      if (node.children && node.children.length > 0) {
        result += formatTreeNodes(node.children, `${prefix}${childPrefix}`, false)
      }
    }
  })
  return result
}

const loadWorkloadDetails = async () => {
  if (!workloadName.value || !gitRepo.value || !environment.value) {
    error.value = 'Missing required parameters'
    return
  }

  try {
    loading.value = true
    error.value = null

    const response = await workloadService.getWorkloadDetails({
      workload: workloadName.value,
      gitRepo: gitRepo.value,
      environment: environment.value,
      limit: 1
    })
    logger.log('Workload details response:', response)
    // @ts-ignore
    if (response && response.length > 0) {
      // @ts-ignore
      workloadDetail.value = response[0]
    } else {
      error.value = 'No workload details found'
    }
  } catch (err) {
    logger.error('Failed to load workload details:', err)
    error.value = 'Failed to load workload details. Please try again.'
  } finally {
    loading.value = false
  }
}

const refreshData = () => {
  loadWorkloadDetails()
}

const copyCommitHash = async () => {
  if (workloadDetail.value?.commitId) {
    try {
      await navigator.clipboard.writeText(workloadDetail.value.commitId)
      copied.value = true
      setTimeout(() => {
        copied.value = false
      }, 2000)
    } catch (err) {
      logger.error('Failed to copy commit hash:', err)
    }
  }
}

const getUserInitials = (email: string): string => {
  if (!email) return '?'
  const parts = email.split('@')[0].split('.')
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
  }
  return email.substring(0, 2).toUpperCase()
}

const formatDate = (dateString: string): string => {
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffHrs = Math.floor(diffMs / (1000 * 60 * 60))

  let relative = ''
  if (diffHrs < 1) {
    relative = 'just now'
  } else if (diffHrs < 24) {
    relative = `${diffHrs} hour${diffHrs !== 1 ? 's' : ''} ago`
  } else {
    const diffDays = Math.floor(diffHrs / 24)
    relative = `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`
  }

  const formatted = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })

  return `${formatted} (${relative})`
}

// Package helper functions
const getDirectVersion = (versions: string[]): string | null => {
  const directVersion = versions.find((v) => v.includes('(direct)'))
  return directVersion ? directVersion.replace(' (direct)', '').trim() : null
}

const getTransitiveVersions = (versions: string[]): string[] => {
  return versions.filter((v) => !v.includes('(direct)')).map((v) => v.trim())
}

const togglePackageExpansion = (packageName: string) => {
  if (expandedPackages.value.has(packageName)) {
    expandedPackages.value.delete(packageName)
  } else {
    expandedPackages.value.add(packageName)
  }
  // Trigger reactivity
  expandedPackages.value = new Set(expandedPackages.value)
}

const navigateToPackage = (packageName: string) => {
  router.push(`/packages/${encodeURIComponent(packageName)}`)
}

// D3.js Tree Rendering
const renderD3Tree = () => {
  if (!d3Container.value || !workloadDetail.value?.depTree) return

  try {
    const treeData: DepTreeNode[] = JSON.parse(workloadDetail.value.depTree)

    // Clear previous content
    d3.select(d3Container.value).selectAll('*').remove()

    const container = d3Container.value
    const width = container.clientWidth
    const height = container.clientHeight

    // Create SVG
    const svg = d3
      .select(container)
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .attr('class', 'w-full h-full')

    const g = svg.append('g')

    // Create zoom behavior
    const zoom = d3
      .zoom<SVGSVGElement, unknown>()
      .scaleExtent([0.1, 3])
      .on('zoom', (event: d3.D3ZoomEvent<SVGSVGElement, unknown>) => {
        g.attr('transform', event.transform.toString())
      })

    svg.call(zoom as any)

    // Convert flat array to hierarchical structure
    const root = d3.hierarchy({ name: 'root', children: treeData } as any)

    // Create tree layout with more vertical spacing
    const treeLayout = d3
      .tree<any>()
      .size([height * 2, width - 200])
      .separation((a, b) => (a.parent === b.parent ? 3 : 4))

    treeLayout(root)

    // Draw links
    g.selectAll('.link')
      .data(root.links())
      .enter()
      .append('path')
      .attr('class', 'link')
      .attr('fill', 'none')
      .attr('stroke', '#94a3b8')
      .attr('stroke-width', 2)
      .attr(
        'd',
        d3
          .linkHorizontal<any, any>()
          .x((d: any) => d.y)
          .y((d: any) => d.x)
      )

    // Draw nodes
    const nodes = g
      .selectAll('.node')
      .data(root.descendants())
      .enter()
      .append('g')
      .attr('class', 'node')
      .attr('transform', (d: any) => `translate(${d.y},${d.x})`)
      .style('cursor', 'pointer')
      .on('click', function (event: any, d: any) {
        if (d.data.name && d.data.name !== 'root') {
          // Highlight this node and its connections
          d3.selectAll('.node circle').attr('fill', '#6366f1').attr('r', 8)
          d3.selectAll('.link').attr('stroke', '#94a3b8').attr('stroke-width', 2)

          // Highlight selected node
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const self = this
          d3.select(self).select('circle').attr('fill', '#f59e0b').attr('r', 10)

          // Highlight connected links
          const nodeId = d.data.name
          d3.selectAll('.link')
            .filter((l: any) => l.source.data.name === nodeId || l.target.data.name === nodeId)
            .attr('stroke', '#f59e0b')
            .attr('stroke-width', 3)
        }
      })

    // Add circles for nodes
    nodes
      .append('circle')
      .attr('r', 8)
      .attr('fill', '#6366f1')
      .attr('stroke', '#fff')
      .attr('stroke-width', 2.5)

    // Add labels
    nodes
      .append('text')
      .attr('dy', '.35em')
      .attr('x', (d: any) => (d.children ? -15 : 15))
      .attr('text-anchor', (d: any) => (d.children ? 'end' : 'start'))
      .attr('font-size', '13px')
      .attr('fill', '#1f2937')
      .attr('class', 'dark:fill-gray-200')
      .text((d: any) => {
        if (d.data.name === 'root') return ''
        // Extract package name and version
        const name = d.data.name
        const parts = name.split('@')
        if (parts.length > 1) {
          return `${parts.slice(0, -1).join('@')}@${parts[parts.length - 1]}`
        }
        return name
      })

    // Center the tree
    const bounds = g.node()?.getBBox()
    if (bounds) {
      const fullWidth = bounds.width
      const fullHeight = bounds.height
      const midX = bounds.x + fullWidth / 2
      const midY = bounds.y + fullHeight / 2

      svg.call(
        zoom.transform as any,
        d3.zoomIdentity.translate(width / 2 - midX, height / 2 - midY).scale(0.4)
      )
    }
  } catch (err) {
    logger.error('Failed to render D3 tree:', err)
  }
}

// Watch for D3 modal opening
watch(showD3Modal, async (newVal) => {
  if (newVal) {
    await nextTick()
    renderD3Tree()
  }
})

// Lifecycle
onMounted(() => {
  loadWorkloadDetails()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "flex items-center space-x-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M15 19l-7-7 7-7"
                })
              ], -1),
              _createElementVNode("span", null, "Back", -1)
            ])),
            _createElementVNode("div", _hoisted_6, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center" }, [
                _createElementVNode("svg", {
                  class: "w-6 h-6 text-blue-600 dark:text-blue-300",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  })
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("h1", _hoisted_7, " 🔧 " + _toDisplayString(workloadName.value), 1),
                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Workload Details", -1))
              ])
            ])
          ]),
          _createElementVNode("div", { class: "flex items-center space-x-3" }, [
            _createElementVNode("button", {
              class: "flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors",
              onClick: refreshData
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                })
              ], -1),
              _createElementVNode("span", null, "Refresh", -1)
            ]))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[18] || (_cache[18] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" }, null, -1),
            _createElementVNode("span", { class: "ml-3 text-gray-600 dark:text-gray-400 text-lg" }, " Loading workload details... ", -1)
          ])))
        : (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-red-500 mb-4" }, [
                _createElementVNode("svg", {
                  class: "w-16 h-16",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ])
              ], -1)),
              _createElementVNode("p", _hoisted_11, _toDisplayString(error.value), 1),
              _createElementVNode("button", {
                class: "mt-6 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors",
                onClick: loadWorkloadDetails
              }, " Try Again ")
            ]))
          : (workloadDetail.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center" }, [
                      _createElementVNode("span", { class: "mr-2" }, "📦"),
                      _createTextVNode(" Overview ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Workload ID:", -1)),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(workloadDetail.value.workloadId), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "App Name:", -1)),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(workloadDetail.value.appName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Git Repository:", -1)),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(workloadDetail.value.gitRepo), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Environment:", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass([
                    'inline-flex items-center px-3 py-1 rounded-md text-sm font-medium',
                    workloadDetail.value.environment === 'interop'
                      ? 'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200'
                      : workloadDetail.value.environment === 'staging'
                        ? 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200'
                        : 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200'
                  ])
                        }, _toDisplayString(workloadDetail.value.environment), 3)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Package Count:", -1)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(workloadDetail.value.packageCount) + " packages ", 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[30] || (_cache[30] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center" }, [
                      _createElementVNode("span", { class: "mr-2" }, "🚀"),
                      _createTextVNode(" Latest Deployment ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Last Deployed:", -1)),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(formatDate(workloadDetail.value.lastDeployed)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Build Number:", -1)),
                        _createElementVNode("span", _hoisted_31, " #" + _toDisplayString(workloadDetail.value.buildNumber), 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Build ID:", -1)),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(workloadDetail.value.buildId), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Triggered By:", -1)),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("span", _hoisted_37, _toDisplayString(getUserInitials(workloadDetail.value.buildUserEmail)), 1)
                          ]),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(workloadDetail.value.buildUserEmail), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _cache[34] || (_cache[34] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center" }, [
                      _createElementVNode("span", { class: "mr-2" }, "🌿"),
                      _createTextVNode(" Git Information ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_42, [
                          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Branch:", -1)),
                          _createElementVNode("span", _hoisted_43, _toDisplayString(workloadDetail.value.branch), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Commit Hash:", -1)),
                            _createElementVNode("button", {
                              class: "text-xs px-3 py-1 text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 bg-blue-50 dark:bg-blue-900/20 rounded flex items-center space-x-1 transition-colors",
                              onClick: copyCommitHash
                            }, [
                              _cache[32] || (_cache[32] = _createElementVNode("svg", {
                                class: "w-3 h-3",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                })
                              ], -1)),
                              _createElementVNode("span", null, _toDisplayString(copied.value ? 'Copied!' : 'Copy'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, _toDisplayString(workloadDetail.value.commitId), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                (workloadDetail.value.packages && Object.keys(workloadDetail.value.packages).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("h2", _hoisted_50, [
                            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "mr-2" }, "📦", -1)),
                            _createTextVNode(" Packages (" + _toDisplayString(Object.keys(workloadDetail.value.packages).length) + ") ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            (workloadDetail.value.depTree)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "flex items-center space-x-2 px-4 py-1.5 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showDepTreeModal.value = true))
                                }, _cache[36] || (_cache[36] = [
                                  _createElementVNode("svg", {
                                    class: "w-4 h-4",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                                    })
                                  ], -1),
                                  _createElementVNode("span", null, "Tree View", -1)
                                ])))
                              : _createCommentVNode("", true),
                            (workloadDetail.value.depTree)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "flex items-center space-x-2 px-4 py-1.5 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showD3Modal.value = true))
                                }, _cache[37] || (_cache[37] = [
                                  _createElementVNode("svg", {
                                    class: "w-4 h-4",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                    })
                                  ], -1),
                                  _createElementVNode("span", null, "Graph View", -1)
                                ])))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((packageSearchQuery).value = $event)),
                              type: "text",
                              placeholder: "Search packages...",
                              class: "px-3 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            }, null, 512), [
                              [_vModelText, packageSearchQuery.value]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("table", _hoisted_53, [
                            _cache[39] || (_cache[39] = _createElementVNode("thead", { class: "bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600" }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, " Package Name "),
                                _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, " Direct Version "),
                                _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, " All Versions ")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", _hoisted_54, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPackages.value, (versions, packageName) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: packageName,
                                  class: "hover:bg-gray-50 dark:hover:bg-gray-750 transition-colors"
                                }, [
                                  _createElementVNode("td", _hoisted_55, [
                                    _createElementVNode("button", {
                                      class: "text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline text-left",
                                      onClick: ($event: any) => (navigateToPackage(packageName))
                                    }, _toDisplayString(packageName), 9, _hoisted_56)
                                  ]),
                                  _createElementVNode("td", _hoisted_57, [
                                    (getDirectVersion(versions))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                                          _createTextVNode(_toDisplayString(getDirectVersion(versions)) + " ", 1),
                                          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "ml-1" }, "✓", -1))
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_59, " - "))
                                  ]),
                                  _createElementVNode("td", _hoisted_60, [
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("div", _hoisted_62, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTransitiveVersions(versions).slice(0, 3), (version, idx) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: idx,
                                            class: "inline-flex items-center px-2 py-0.5 rounded text-xs font-mono bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
                                          }, _toDisplayString(version), 1))
                                        }), 128))
                                      ]),
                                      (getTransitiveVersions(versions).length > 3)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline whitespace-nowrap",
                                            onClick: ($event: any) => (togglePackageExpansion(packageName))
                                          }, _toDisplayString(expandedPackages.value.has(packageName)
                              ? 'Show less'
                              : `+${getTransitiveVersions(versions).length - 3} more`), 9, _hoisted_63))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (expandedPackages.value.has(packageName) && getTransitiveVersions(versions).length > 3)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTransitiveVersions(versions).slice(3), (version, idx) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: idx,
                                              class: "inline-flex items-center px-2 py-0.5 rounded text-xs font-mono bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
                                            }, _toDisplayString(version), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          (Object.keys(filteredPackages.value).length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                _createElementVNode("p", _hoisted_66, " No packages found matching \"" + _toDisplayString(packageSearchQuery.value) + "\" ", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
    ]),
    (showDepTreeModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-50 overflow-y-auto",
          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (showDepTreeModal.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", {
              class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75 dark:bg-gray-900 dark:bg-opacity-75",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showDepTreeModal.value = false))
            }),
            _createElementVNode("div", {
              class: "inline-block w-full max-w-4xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-gray-800 shadow-xl rounded-2xl",
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_68, [
                _cache[41] || (_cache[41] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white flex items-center" }, [
                  _createElementVNode("svg", {
                    class: "w-6 h-6 mr-2 text-purple-600 dark:text-purple-400",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                    })
                  ]),
                  _createTextVNode(" Dependency Tree ")
                ], -1)),
                _createElementVNode("button", {
                  class: "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showDepTreeModal.value = false))
                }, _cache[40] || (_cache[40] = [
                  _createElementVNode("svg", {
                    class: "w-6 h-6",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("pre", _hoisted_71, _toDisplayString(formattedDepTree.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("button", {
                  class: "px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showDepTreeModal.value = false))
                }, " Close ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showD3Modal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 z-50 overflow-y-auto",
          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (showD3Modal.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", {
              class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75 dark:bg-gray-900 dark:bg-opacity-75",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (showD3Modal.value = false))
            }),
            _createElementVNode("div", {
              class: "inline-block w-full max-w-6xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-gray-800 shadow-xl rounded-2xl",
              onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_74, [
                _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white flex items-center" }, [
                  _createElementVNode("svg", {
                    class: "w-6 h-6 mr-2 text-indigo-600 dark:text-indigo-400",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    })
                  ]),
                  _createTextVNode(" Dependency Graph ")
                ], -1)),
                _createElementVNode("button", {
                  class: "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (showD3Modal.value = false))
                }, _cache[42] || (_cache[42] = [
                  _createElementVNode("svg", {
                    class: "w-6 h-6",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", {
                  ref_key: "d3Container",
                  ref: d3Container,
                  class: "bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden",
                  style: {"height":"70vh"}
                }, null, 512)
              ]),
              _createElementVNode("div", _hoisted_76, [
                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "text-sm text-gray-600 dark:text-gray-400" }, " 💡 Tip: Scroll to zoom, drag to pan, click nodes to highlight dependencies ", -1)),
                _createElementVNode("button", {
                  class: "px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (showD3Modal.value = false))
                }, " Close ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})